import React from 'react';
import Tooltip from '../tooltip/Tooltip';
import './Input.css';


const isEnabled = (enable) => {
  let isInputEnabled;
  switch (enable) {
    case true:
      isInputEnabled = '';
      break;
    case false:
      isInputEnabled = 'disabled';
      break;
    default:
      isInputEnabled = ''
  }
  return isInputEnabled;
}

const Input = ({
  type,
  funcionBlur,
  funcionFocus,
  placeHolder,
  nombreInput,
  htmlForLabel,
  htmlForInfo,
  funcionOnChange,
  htmlForAlert,
  largoMaximo,
  validarAlert,
  valor,
  funcionClick,
  enable,
  reference,
  tooltip,
  tooltipTag
}) => {
  return (
    <label htmlFor={htmlForLabel}>
      <span className="labelInput">
        {htmlForLabel}
        {tooltip &&  <Tooltip message={tooltip} tag={tooltipTag} />}
      </span>
      <input
        type={type}
        name={nombreInput}
        placeholder={placeHolder}
        onClick={funcionClick}
        onBlur={funcionBlur}
        onFocus={funcionFocus}
        maxLength={largoMaximo}
        onChange={funcionOnChange}
        value={valor}
        disabled={isEnabled(enable)}
        ref={reference}
      />
      <span className="infoInput">{htmlForInfo}</span>
      {validarAlert ? <span className="alertInput">{htmlForAlert}</span> : null}
    </label>
  );
};

export default Input;